module.exports = __webpack_public_path__ + "static/Chat app-6497defcd2c96251eccce5c737f9e307.png";